<template>
  <footer class="footer">
    <div class="foot_bottom">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8">
            <p><a class="f_util" href="https://www.bespinglobal.com/privacy-statement/privacy/" target="_blank" rel="noopener">개인정보 처리방침</a></p>
            <span class="foot_txt"><strong>대표이사</strong>이해민, LEE JOHN HANJOO</span><span class="foot_txt ft_pd16"><strong>주소</strong>서울특별시 서초구 강남대로 327</span><span class="foot_txt"><strong>전화번호</strong>+82 1668-1280</span><br/>
            <span class="foot_txt">Copyright © 2022 BESPIN GLOBAL. All Rights Reserved.</span>
          </div>
          <div class="col-md-4 ft_logo">
            <img src="@/assets/image/foot_logo.png"/>
          </div>
        </div>
      </div>
    </div>
    <a id="backToTop" class="scrolltop" href="#"></a>
  </footer>
</template>

<script>
  export default {
    name: 'BaseFooter',
    components: {
      
    },
    data() {
      return {   
         
      }
    },
    computed: {},
    watch: {},
    created(){},
    mounted(){},
    beforeDestroy() {},
    methods: {}
  }
</script>

<style lang="scss" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/BaseFooter.vue